import { ReactElement } from "react";
import { TailSpin } from "react-loader-spinner";
import { useAuth } from "../context/AuthContext";

export function AdminRedirectRoute({ children }: { children: ReactElement }): ReactElement {
    const { isLoading, isAuthenticated, user } = useAuth();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#F4F5F7]">
                <TailSpin color="rgb(17,58,40)" height={80} width={80} />
            </div>
        );
    }

    if (isAuthenticated && user?.is_admin) {
        window.location.replace("/live-classes/");
        return <></>;
    }

    return children;
}
